import { render, staticRenderFns } from "./CoozzyFormCopyInput.vue?vue&type=template&id=2c1f8ee7&scoped=true"
import script from "./CoozzyFormCopyInput.vue?vue&type=script&lang=js"
export * from "./CoozzyFormCopyInput.vue?vue&type=script&lang=js"
import style0 from "./CoozzyFormCopyInput.vue?vue&type=style&index=0&id=2c1f8ee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f8ee7",
  null
  
)

export default component.exports